import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SessionsAndBlocklistTabs = _resolveComponent("SessionsAndBlocklistTabs")!
  const _component_FiltersSmall = _resolveComponent("FiltersSmall")!
  const _component_EditBlocklistForm = _resolveComponent("EditBlocklistForm")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_NInfiniteScroll = _resolveComponent("NInfiniteScroll")!
  const _component_SettingsMenu = _resolveComponent("SettingsMenu")!
  const _component_BlocklistMultitool = _resolveComponent("BlocklistMultitool")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    state: _ctx.state,
    statistics: false,
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    class: "blocklist-page",
    ref: "listPage"
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_SessionsAndBlocklistTabs),
      _createVNode(_component_FiltersSmall, {
        "form-layout": _ctx.getSmallFilterLayout,
        modelValue: _ctx.module.filter.current,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current) = $event)),
        onResetFilters: _ctx.resetFilters,
        collapsed: false
      }, {
        actions: _withCtx(() => [
          _hoisted_1
        ]),
        "filter-manager": _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["form-layout", "modelValue", "onResetFilters"])
    ]),
    summary: _withCtx(() => [
      _hoisted_3
    ]),
    items: _withCtx(() => [
      (_ctx.showModalWindow && _ctx.modelAcl.update)
        ? (_openBlock(), _createBlock(_component_EditBlocklistForm, {
            key: 0,
            model: _ctx.module.currentItem.item,
            onClose: _ctx.closeHandler,
            onSave: _ctx.saveHandler
          }, null, 8, ["model", "onClose", "onSave"]))
        : _createCommentVNode("", true),
      (_ctx.module.loaded && _ctx.items.length)
        ? (_openBlock(), _createBlock(_component_NTable, {
            key: 1,
            columns: _ctx.columns,
            content: _ctx.items,
            onAction: _ctx.handleTableAction,
            onSort: _ctx.handleTableSort,
            "selected-items-ids": _ctx.module.selectedItemIds
          }, null, 8, ["columns", "content", "onAction", "onSort", "selected-items-ids"]))
        : _createCommentVNode("", true),
      _createVNode(_component_NInfiniteScroll, {
        filters: _ctx.module.filter.current,
        onLoadMore: _cache[1] || (_cache[1] = ($event: any) => (_ctx.module.append()))
      }, null, 8, ["filters"])
    ]),
    "left-bar": _withCtx(() => [
      _createVNode(_component_SettingsMenu)
    ]),
    multitool: _withCtx(() => [
      (_ctx.selectedItems.length)
        ? (_openBlock(), _createBlock(_component_BlocklistMultitool, {
            key: 0,
            "selected-items": _ctx.selectedItems,
            "changed-count": _ctx.module.changedSelectedItemsCount,
            "model-acl": _ctx.modelAcl,
            onAction: _ctx.handleAction
          }, null, 8, ["selected-items", "changed-count", "model-acl", "onAction"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4))
    ]),
    _: 1
  }, 8, ["state", "onUpdate:scrollBottom"]))
}